import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./usermodal.scss";
import Cropper from "react-easy-crop";
import { useAuth } from "../../../context/Auth";
import { postData } from "../../../../Utils/commonApi";
import { useDispatch } from "react-redux";
import { setuser } from "../../../../redux/userState/actions";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import { TrackUser } from "../../../../Utils/SegmentFunctions";
import { updateAccessKeyInLocalStorage } from "../../../../Utils/CommonFunctions copy";

function ImageCropperModal({
  show,
  hideModal,
  setProfileImage,
  profileImage,
  uploadType,
  clientId,
  memberId,
  cropShape = "round",
  passedOptionEnum99,
  refreshData = () => { }
}) {
  const dispatch = useDispatch();
  const { authTokens } = useAuth();
  const [loading, setLoading] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropDims, setCropDims] = useState({});
  const [styles] = useState({
    containerStyle: {
      width: "calc(100% - 2px)",
      maxHeight: "300px",
      overflow: "hidden",
      backgroundColor: "white",
    },
    cropAreaStyle: {
      outline: "50000px solid white",
      width: "100%",
      height: "100%",
    },
  });

  const onCropComplete = (e, imageDimensions) => { setCropDims(imageDimensions) };
  const onCropChange = (crop) => { setCrop(crop) };

  const onSubmit = async () => {
    setLoading(true);
    const createImage = (url) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) => reject(error));
        image.setAttribute("crossOrigin", "anonymous");
        image.src = url;
      });

    const Imagee = await createImage(profileImage)
      .then(async (Imagee) => {
        const canvas = document.createElement("canvas");
        canvas.height = cropDims.height;
        canvas.width = cropDims.width;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(Imagee, cropDims.x, cropDims.y, cropDims.width, cropDims.height, 0, 0, cropDims.width, cropDims.height);

        if (uploadType === 99 && !memberId) {
          setProfileImage(canvas.toDataURL("image/png"));
          hideModal();
          setLoading(false);
          return
        }
        if (uploadType === 1) {
          await postData(authTokens, memberId ? "UploadProfilePhoto" : "UploadFile", memberId ? {
            optionEnum1: 0,
            optionStrEnum1: memberId,
            optionEnum99: passedOptionEnum99 ? passedOptionEnum99 : 42,
            File: canvas.toDataURL("image/png"),
          } : {
            optionEnum1: 1,
            File: canvas.toDataURL("image/png"),
            optionEnum98: clientId
          }).then((response) => {
            if (response?.mr?.Success) {
              if (!memberId) {
                updateAccessKeyInLocalStorage(response?.mr?.Message)
                setProfileImage(canvas.toDataURL("image/png"));
              }

              TrackUser(`${memberId ? 'Photo' : 'Logo'} uploaded`);
              CallToast(`${memberId ? 'Photo' : 'Logo'} uploaded successfully`, false, false, "v2style");
              hideModal();
              setLoading(false);
              refreshData(response);
            } else {
              CallToast("Something went wrong", false, false, "v2style");
              hideModal();
            }
          });

          return;
        } else {
          const response = await postData(authTokens, memberId ? "UploadProfilePhoto" : "UploadFile", memberId ? {
            optionEnum1: 0,
            optionStrEnum1: memberId,
            optionEnum99: passedOptionEnum99 ? passedOptionEnum99 : 42,
            File: canvas.toDataURL("image/png"),
          } : {
            optionEnum1: 0,
            File: canvas.toDataURL("image/png"),
          });

          if (response?.mr?.Success == true) {
            if (!memberId) {
              updateAccessKeyInLocalStorage(response?.mr?.Message)
              dispatch(setuser({ Avatar: response.FileURL }));
            }

            TrackUser("Photo uploaded");
            CallToast("Photo uploaded successfully", false, false, "v2style");
            hideModal();
            setLoading(false);
            refreshData(response);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  function progressColor(rangeValue) {
    let max = 3;
    let min = 1;
    let value = ((rangeValue - min) / (max - min)) * 100;
    const slider = document.getElementById("zoom-slider");
    slider.style.background = "linear-gradient(to right, #008fd4 0%, #008fd4 " + value + "%, #fff " + value + "%, white 100%)";
  }

  return (
    <Modal
      animation={false}
      show={show}
      dialogClassName="image-crop-modal"
      className=""
      aria-labelledby="cropper-modal-title-vcenter"
      centered
      scrollable
    >
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div>
          <Cropper
            image={profileImage}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape={cropShape}
            showGrid={false}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={() => { }}
            style={styles}
          />
        </div>

        <div className="d-flex slider-wrapper w-80">
          <img
            src="/images/user-modal/minus.svg"
            className={`mr-3 p-1 ${Number(zoom) > 1 ? 'pointer' : 'cursor-default'}`}
            onClick={() => {
              if (zoom > 1) {
                setZoom((Number(zoom) - 0.1)?.toFixed(1)?.toString());
                progressColor((Number(zoom) - 0.1)?.toFixed(1)?.toString());
              }
            }}
          />
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => {
              setZoom(e.target.value);
              progressColor(e.target.value);
            }}
            className="slider"
            id="zoom-slider"
          />
          <img
            src="/images/user-modal/plus.svg"
            className={`ml-3 p-1 ${Number(zoom) < 3 ? 'pointer' : 'cursor-default'}`}
            onClick={() => {
              if (zoom < 3) {
                setZoom((Number(zoom) + 0.1)?.toFixed(1)?.toString());
                progressColor((Number(zoom) + 0.1)?.toFixed(1)?.toString());
              }
            }}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="footer d-flex justify-content-end">
          <Button disabled={loading} className="crop-save-btn" onClick={() => { onSubmit() }}>
            {loading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ImageCropperModal;
